const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class SportsService {
  static getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // Get all sports (public)
  static async getSports(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        includeInactive: params.includeInactive || false,
        season: params.season || '',
        gender: params.gender || ''
      });

      const response = await fetch(`${API_BASE_URL}/sports?${queryParams}`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch sports: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching sports:', error);
      throw error;
    }
  }

  // Get all sports for admin (includes inactive)
  static async getAllSports(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        page: params.page || 1,
        limit: params.limit || 50,
        search: params.search || '',
        season: params.season || '',
        gender: params.gender || '',
        includeInactive: params.includeInactive || true
      });

      const response = await fetch(`${API_BASE_URL}/sports?${queryParams}`, {
        headers: this.getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch admin sports: ${response.statusText}`);
      }

      const result = await response.json();
      console.log('SportsService.getAllSports response:', result);
      return result;
    } catch (error) {
      console.error('Error fetching admin sports:', error);
      throw error;
    }
  }

  // Get sport by ID
  static async getSport(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/sports/${id}`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch sport: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching sport:', error);
      throw error;
    }
  }

  // Create new sport (admin only)
  static async createSport(sportData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sports`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(sportData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create sport');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating sport:', error);
      throw error;
    }
  }

  // Update sport (admin only)
  static async updateSport(id, sportData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sports/${id}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(sportData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update sport');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating sport:', error);
      throw error;
    }
  }

  // Delete sport (admin only)
  static async deleteSport(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/sports/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to delete sport');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting sport:', error);
      throw error;
    }
  }

  // Get sport statistics (admin only)
  static async getSportStats(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/sports/${id}/stats`, {
        headers: this.getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch sport stats: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching sport stats:', error);
      throw error;
    }
  }
}

export default SportsService;